import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import HomeworkResult from '../../template/HomeworkNew/HomeworkResult';
import StepChange from '../../template/HomeworkNew/StepChange';
import clientApi from '../../api/client';
import { parseQuery } from '../../utils/tools';
import BASE_CONFIG from '../../api/env';
import AXIOS from '../../api/axios';


class HomeworkResultPage extends Component {
    constructor(props) {
        super(props);
        this.queryObj = parseQuery(window.location.search.slice(1))
        const { courseid } = this.queryObj;
        this.state = {
            showStepChange: true,
            shareParams: null
        };
        this.shareKey = courseid + '_H5HomeWorkShare'; // 分享内链配置key,
        this.timeOutArr = [];
    }
    componentDidMount() {
        AXIOS.homeworkEnd({
            data:{
                classSchId: this.queryObj.classschid,
                type: 0
            }
        },(res, err)=>{
            if(err) console.log(err.errorMessage)
            else{
                this.setState({
                    awardCnt: res.awardCnt,
                    starnum: res.score,
                    completeRender: true
                },()=>{
                    this.stepChangeRef.cloudPlay(()=>{
                        this.timeOutArr.push(
                            setTimeout(() => {
                                this.setState({
                                    showStepChange: false,
                                    stepChange: 'out'
                                })
                            }, 1200)
                        );
                    })
                })
            }
        })
        AXIOS.getShareConfigByKey({ data: { key: this.shareKey } }, (res, err) => {
            const shareParams = res;
            console.log('shareParams==', shareParams);
            this.setState({ shareParams });
        })
    }
    handleDone = () => {
        clientApi.eventTracking({eventType:'c2_app_HomeWork_End_Complete'});
        clientApi.closeH5Page({reason: 'homeworkDone'});
    }
    handleShare = () => {
        const { shareParams } = this.state;
        if (!shareParams) return;
        return clientApi.shareNew({
            ...shareParams,
            type: 2,
            shareByUrl: true,
            shareUrl: `${BASE_CONFIG.wxBaseUrl}/h5/share-work?stuId=${this.queryObj.userid}&classSchId=${this.queryObj.classschid}`,
            resource: 'homework'
        })
    }
    render() {
        const { stepChange, showStepChange, starnum, awardCnt, completeRender, shareParams } = this.state;
        return (
            <DocumentTitle title={'课后作业'}>
                <React.Fragment>
                    {completeRender &&
                        <HomeworkResult starnum={starnum} awardCnt={awardCnt} handleDone={this.handleDone} handleShare={this.handleShare} isShowShare={!!shareParams} />
                    }
                    {showStepChange && (
                        <StepChange status={stepChange || 'in'} ref={com => this.stepChangeRef = com} />
                    )}
                </React.Fragment>
            </DocumentTitle>
        );
    }
}

export default HomeworkResultPage;



// WEBPACK FOOTER //
// ./src/components/homeworkNewPage/HomeworkResultPage.jsx